module.exports = __webpack_public_path__ + "media/flags/tj-bf3afdf3.svg";